import { io } from "socket.io-client";
import { v4 as uuidv4 } from "uuid";
import { serverLink } from "../api/serverLink";
import { getStore } from "../store/store";
import { attachSocketEvents } from "./socketEvents/attachSocketEvents";

let socket = null;
const sessionId = uuidv4();

/** Prefer Redux (kept in sync on refresh); fall back to localStorage for reconnect races */
function getAuthTokenForSocket() {
  return (
    getStore().getState().user?.token || localStorage.getItem("authToken")
  );
}

const setupSocketListeners = (dispatch) => {
  if (!socket) return;

  let forceDisconnected = false;

  const onConnect = () => {
    attachSocketEvents(socket, dispatch);
  };

  socket.off("connect", onConnect);
  socket.on("connect", onConnect);

  socket.on("forceLogout", ({ reason }) => {
    forceDisconnected = true;
    disconnectSocket();
  });

  socket.on("connect_error", (error) => {
    console.warn("Socket connect_error:", error?.message ?? error);
  });

  socket.on("disconnect", (reason) => {
    console.warn("Socket disconnected:", reason);
    if (reason === "io server disconnect" && !forceDisconnected) {
      setTimeout(() => {
        const token = getAuthTokenForSocket();
        if (token) {
          socket.auth = { token, sessionId };
          socket.connect();
        }
      }, 3000);
    }
  });

  socket.on("reconnect_attempt", () => {
    const token = getAuthTokenForSocket();
    socket.auth = token ? { token, sessionId } : {};
    console.info("Socket reconnect_attempt with auth", socket.auth);
  });
};

export const connectSocket = (dispatch) => {
  const token = getAuthTokenForSocket();
  if (!token) return;

  if (socket) {
    socket.removeAllListeners();
    socket.disconnect();
    socket = null;
  }

  socket = io(serverLink, {
    transports: ["websocket"],
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    // Keep-alive tuning to avoid idle disconnects
    pingInterval: 20000,
    pingTimeout: 5000,
    timeout: 10000,
    auth: {
      token,
      sessionId,
    },
  });

  setupSocketListeners(dispatch);
};

export const getSocket = () => socket;

export const disconnectSocket = () => {
  if (socket) {
    socket.removeAllListeners();
    socket.disconnect();
    socket = null;
  }
};
